import React, { useState } from "react";
import firebase from "firebase";
import { useAlert } from "react-alert";
import firebaseApp from "../../../Firebase/firebase";
import { LeftOutlined } from "@ant-design/icons";
import AddNewUser from "./AddNewUser";
import { useQuery, useMutation } from "@apollo/client";
import {
  Text,
  DropDownMenu,
  UploadLogo,
  UploadFile,
  Switch,
  Checkbox,
  Calender,
  TableAction,
} from "../../formitems/Index";
import {
  existuser,
  dataAdminsss,
  AddUser_Simulator,
  Add_User_Register,
  AddUser_Manager,
  AddUser_Aircraft,
  Add_User_Ground,
  AddUser_Crew,
  Add_User_UserTable,
  addUser_Optimiser,
} from "../../../Queries/User/User";
import EditUser from "./EditUser";
import {
  Client,
  GetUsers,
  ActiveUsers,
  ActiveUserCrew,
  ActiveUserGround,
  ActiveUserSimulator,
  ActiveUserAircraft,
  ActiveUserManager,
  ActiveUserDataAdmin,
  ActiveUserOptimiser,
  user_active,
  aircraft_active,
  crew_active,
  dataAdmin_active,
  ground_active,
  manager_active,
  optimiser_active,
  simulator_active,
  register_active,
} from "../../../Queries/User/EditUser";
import BulkAppend from "./BulkAppend";
const Users = () => {
  let [countUser, setCountUser] = useState(0);
  let [countEdit, setCountEdit] = useState(0);
  const alert = useAlert();
  const [bulk_append, setbulk_append] = useState(false);
  const [bulk_update, setbulk_update] = useState(false);
  const [active_row, setactive_row] = useState({});
  const [active_row_index, setactive_row_index] = useState(null);
  const [manage_user_table, setmanage_user_table] = useState(false);
  const [dropdown2, setdropdown2] = useState("");
  const [toggle, settoggle] = useState(true);
  // new start
  let [email, setEmail] = useState("");
  let [client, setClient] = useState("");
  let [userClient, setUserClient] = useState("");
  let [processing, setProcessing] = useState(false);
  const [temp_user_form, settemp_user_form] = useState(false);
  const [temp_edit_user_form, settemp_edit_user_form] = useState(false);
  // new end
  const [manage_user_form, setmanage_user_form] = useState(false);
  const [search, setsearch] = useState("");
  // const [row_items, setrow_items] = useState([{
  //   id: "1",
  //   client: "One Air",
  //   client_name: "ATPL",
  //   email: "Airline Transport Pilot Licence",
  //   e_code: "Current Rating",
  //   phone: "Status (PIC/ P2)",
  //   rank: "Restrictions",
  //   licence_number: "30",
  //   permissions: {
  //     crew: true,
  //     ground: true,
  //     aircraft: true,
  //     simulator: true,
  //     manager: true,
  //     optimizer: true,
  //     data_admin: true,
  //   },
  // },])
  const openBulkAppendUpdate = (type) => {
    console.log("type", type);
    if (type === "BulkAppend") {
      setbulk_append(true);
    } else if (type === "BulkUpdate") {
      setbulk_update(true);
    }
  };

  const openManageUser = () => {
    setmanage_user_table(true);
  };

  //new start
  const openTempUserForm = () => {
    if (countUser === 0) {
      setCountUser(1);
      firebase
        .firestore()
        .collection("clients")
        .get()
        .then((doc) => {
          let clientList = doc.docs;
          let clientHTMLElement = document.getElementById("userClient");
          clientList.forEach((item) => {
            let user = item.data();
            clientHTMLElement.innerHTML += `<option value="${user.clientname}">${user.clientname}</option>`;
          });
          return settemp_user_form(true);
        })
        .catch((err) => {
          settemp_user_form(true);
          throw err;
        });
    } else {
      setUserClient("");
      return settemp_user_form(true);
    }
  };

  const openTempEditUserForm = () => {
    if (countEdit === 0) {
      setCountEdit(1);
      firebase
        .firestore()
        .collection("users")
        .get()
        .then((doc) => {
          let emailList = doc.docs;
          let emailHTMLElement = document.getElementById("updateEmail");
          emailList.forEach((item) => {
            let user = item.data();
            emailHTMLElement.innerHTML += `<option value="${user.email}">${user.email}</option>`;
          });
          return setEmail("");
        })
        .catch((err) => {
          throw err;
        });
      firebase
        .firestore()
        .collection("clients")
        .get()
        .then((doc) => {
          let clientList = doc.docs;
          let clientHTMLElement = document.getElementById("updateClient");
          clientList.forEach((item) => {
            let user = item.data();
            clientHTMLElement.innerHTML += `<option value="${user.clientname}">${user.clientname}</option>`;
          });
          setEmail("");
          return settemp_edit_user_form(true);
        })
        .catch((err) => {
          settemp_edit_user_form(true);
          throw err;
        });
    } else {
      setEmail("");
      setClient("");
      settemp_edit_user_form(true);
    }
  };
  // new end

  const add_new_user = () => {
    setmanage_user_table(false);
    setmanage_user_form(true);
  };

  // new start

  const authNames = [
    "_crew",
    "_ground",
    "_aircraft",
    "_simulator",
    "_manager",
    "_optimiser",
    "_dataadmin",
  ];

  const registerUser = async (e) => {
    e.preventDefault();

    let createNewUser = firebase.functions().httpsCallable("adminCreateUser");

    let email = document.getElementById("userEmail").value;
    let clientInput = document.getElementById("userClient").value;
    let active = document.getElementById("activeStatus").checked;
    let auths = document.getElementsByClassName("userAuth");

    let { clientid, clientname } = await firebase
      .firestore()
      .collection("clients")
      .where("clientname", "==", clientInput)
      .get()
      .then((fetchClient) => {
        let updatedClient = fetchClient.docs[0].data();
        return {
          clientid: updatedClient.clientsid,
          clientname: updatedClient.clientname,
        };
      })
      .catch((err) => {
        alert.show(`${err}`, {
          timeout: 3000,
          type: "error",
        });
        throw err;
      });

    let data = {
      email: email,
      active: active,
      clientid: clientid,
      clientname: clientname,
    };

    for (let index = 0; index < auths.length; index++) {
      const element = auths.item(index);
      const name = authNames[index];
      data[name] = element.checked;
    }

    createNewUser({ user: data })
      .then(() => {
        alert.show("User creation successful!!", {
          timeout: 3000,
          type: "success",
        });
        console.log("User creation Successfull!!");
        return settemp_user_form(false);
      })
      .catch((err) => {
        alert.show(`${err}`, {
          timeout: 3000,
          type: "error",
        });
        console.log(`Error Occured!! ${err}`);
        settemp_user_form(false);
      });
    return null;
  };

  const updateEmail = (e) => {
    e.preventDefault();
    setEmail(e.target.value);
    console.log(
      `email: ${e.target.value}\nemail length: ${e.target.value.length}`
    );
    if (e.target.value.length) {
      setProcessing(true);
      firebase
        .firestore()
        .collection("users")
        .where("email", "==", e.target.value)
        .get()
        .then((doc) => {
          let user;
          let fetchedDoc = doc.docs[0];
          if (fetchedDoc.exists) {
            user = fetchedDoc.data();
            setClient(user.clientname);
          } else {
            setClient("");
          }
          setProcessing(false);
          return console.log(user.clientname);
        })
        .catch((err) => {
          setClient("");
          setProcessing(false);
          throw err;
        });
    } else {
      setClient("");
    }
  };

  const updateUser = (e) => {
    e.preventDefault();

    let email = document.getElementById("updateEmail").value;
    let client = document.getElementById("updateClient").value;
    let active = document.getElementById("updateStatus").checked;
    let auths = document.getElementsByClassName("updateAuth");

    firebase
      .firestore()
      .collection("users")
      .where("email", "==", email)
      .get()
      .then(async (doc) => {
        let user = await doc.docs[0];
        let { clientid, clientname } = await firebase
          .firestore()
          .collection("clients")
          .where("clientname", "==", client)
          .get()
          .then((client) => {
            let updatedClient = client.docs[0].data();
            return {
              clientid: updatedClient.clientsid,
              clientname: updatedClient.clientname,
            };
          })
          .catch((err) => {
            alert.show(`${err}`, {
              timeout: 3000,
              type: "error",
            });
            throw err;
          });

        let data = {
          active: active,
          clientid: clientid,
          clientname: clientname,
        };

        for (let index = 0; index < auths.length; index++) {
          const element = auths.item(index);
          const name = authNames[index];
          if (element.checked) data[name] = true;
          else data[name] = false;
        }

        firebase
          .firestore()
          .collection("users")
          .doc(user.id)
          .update(data)
          .then((doc) => {
            alert.show("User updated!!", {
              timeout: 3000,
              type: "success",
            });
            console.log("User updated !!");
            settemp_edit_user_form(false);
            return null;
          })
          .catch((err) => {
            alert.show(`${err}`, {
              timeout: 3000,
              type: "error",
            });
            settemp_edit_user_form(false);
            throw err;
          });
        return null;
      })
      .catch((err) => {
        alert.show(`${err}`, {
          timeout: 3000,
          type: "error",
        });
        settemp_edit_user_form(false);
        throw err;
      });
  };
  // new end

  const closeForm = () => {
    setbulk_update(false);
    setbulk_append(false);
    setmanage_user_form(false);
    setmanage_user_table(false);
  };
  const togle = () => {
    toggle ? settoggle(false) : settoggle(true);
  };
  const [Active, setActive] = useState(true);

  const [aircraft1, setAircraft1] = useState(false);
  const [crew1, setCrew1] = useState(false);
  const [ground1, setGround1] = useState(false);
  const [simulator1, setsimulator1] = useState(false);
  const [managerr1, setmanagerr1] = useState(false);
  const [optimiser1, setoptimiser1] = useState(false);
  const [dataAdmin1, setdataAdmin1] = useState(false);
  const [Active1, setActive1] = useState(false);
  const [emails, setEmails] = useState("");

  const { data: clientss } = useQuery(Client);
  const { data: exist } = useQuery(existuser, {
    variables: { email: emails },
  });
  const { data: getuserss } = useQuery(GetUsers, {
    variables: {
      clientid: dropdown2[1],
      active: Active,
    },
  });

  const [adduserInregister, { data: register }] = useMutation(
    Add_User_Register
  );
  const [userAddUsertable, { data: table }] = useMutation(Add_User_UserTable);
  const [addUserOptimiser, { data: optim }] = useMutation(addUser_Optimiser);
  const [addUserCrew, { data: creww }] = useMutation(AddUser_Crew);
  const [addUserGround, { data: groundd }] = useMutation(Add_User_Ground);
  const [addUserAircraft, { data: aircraftss }] = useMutation(AddUser_Aircraft);
  const [addUserManager, { data: managersss }] = useMutation(AddUser_Manager);
  const [addUserSimulator, { data: simulatorsss }] = useMutation(
    AddUser_Simulator
  );
  const [dataaAdminn, { data: admin }] = useMutation(dataAdminsss);

  // Edit Mutation
  const [ActiveUserss, { data: ac }] = useMutation(ActiveUsers, {
    refetchQueries: [
      { query: GetUsers, variables: { active: true, clientid: dropdown2[1] } },
      { query: GetUsers, variables: { active: false, clientid: dropdown2[1] } },
    ],
  });
  const [ActiveUserssCrews, { data: cr }] = useMutation(ActiveUserCrew, {
    refetchQueries: [
      { query: GetUsers, variables: { active: true, clientid: dropdown2[1] } },
      { query: GetUsers, variables: { active: false, clientid: dropdown2[1] } },
    ],
  });
  const [ActiveUserssGroundss, { data: gr }] = useMutation(ActiveUserGround, {
    refetchQueries: [
      { query: GetUsers, variables: { active: true, clientid: dropdown2[1] } },
      { query: GetUsers, variables: { active: false, clientid: dropdown2[1] } },
    ],
  });
  const [ActiveUsersssimulatorss, { data: sims }] = useMutation(
    ActiveUserSimulator,
    {
      refetchQueries: [
        {
          query: GetUsers,
          variables: { active: true, clientid: dropdown2[1] },
        },
        {
          query: GetUsers,
          variables: { active: false, clientid: dropdown2[1] },
        },
      ],
    }
  );
  const [ActiveUserssaircraft, { data: ai }] = useMutation(ActiveUserAircraft, {
    refetchQueries: [
      { query: GetUsers, variables: { active: true, clientid: dropdown2[1] } },
      { query: GetUsers, variables: { active: false, clientid: dropdown2[1] } },
    ],
  });
  const [ActiveUserssmanagerss, { data: man }] = useMutation(
    ActiveUserManager,
    {
      refetchQueries: [
        {
          query: GetUsers,
          variables: { active: true, clientid: dropdown2[1] },
        },
        {
          query: GetUsers,
          variables: { active: false, clientid: dropdown2[1] },
        },
      ],
    }
  );
  const [ActiveUserssdataAdminss, { data: da }] = useMutation(
    ActiveUserDataAdmin,
    {
      refetchQueries: [
        {
          query: GetUsers,
          variables: { active: true, clientid: dropdown2[1] },
        },
        {
          query: GetUsers,
          variables: { active: false, clientid: dropdown2[1] },
        },
      ],
    }
  );
  const [ActiveUserssoptimiser, { data: op }] = useMutation(
    ActiveUserOptimiser,
    {
      refetchQueries: [
        {
          query: GetUsers,
          variables: { active: true, clientid: dropdown2[1] },
        },
        {
          query: GetUsers,
          variables: { active: false, clientid: dropdown2[1] },
        },
      ],
    }
  );

  const [aircraft_actives, { data: aractivess }] = useMutation(
    aircraft_active,
    {
      refetchQueries: [
        {
          query: GetUsers,
          variables: { active: Active, clientid: dropdown2[1] },
        },
      ],
    }
  );
  const [crew_actives, { data: crwe }] = useMutation(crew_active, {
    refetchQueries: [
      {
        query: GetUsers,
        variables: { active: Active, clientid: dropdown2[1] },
      },
    ],
  });
  const [dataAdmin_actives, { data: dataadminssss }] = useMutation(
    dataAdmin_active,
    {
      refetchQueries: [
        {
          query: GetUsers,
          variables: { active: true, clientid: dropdown2[1] },
        },
        {
          query: GetUsers,
          variables: { active: false, clientid: dropdown2[1] },
        },
      ],
    }
  );
  const [ground_activs, { data: grngd }] = useMutation(ground_active, {
    refetchQueries: [
      { query: GetUsers, variables: { active: true, clientid: dropdown2[1] } },
      { query: GetUsers, variables: { active: false, clientid: dropdown2[1] } },
    ],
  });
  const [manager_actives, { data: maactive }] = useMutation(manager_active, {
    refetchQueries: [
      { query: GetUsers, variables: { active: true, clientid: dropdown2[1] } },
      { query: GetUsers, variables: { active: false, clientid: dropdown2[1] } },
    ],
  });
  const [optimiser_actives, { data: optmiser }] = useMutation(
    optimiser_active,
    {
      refetchQueries: [
        {
          query: GetUsers,
          variables: { active: true, clientid: dropdown2[1] },
        },
        {
          query: GetUsers,
          variables: { active: false, clientid: dropdown2[1] },
        },
      ],
    }
  );
  const [simulator_actives, { data: simula }] = useMutation(simulator_active, {
    refetchQueries: [
      { query: GetUsers, variables: { active: true, clientid: dropdown2[1] } },
      { query: GetUsers, variables: { active: false, clientid: dropdown2[1] } },
    ],
  });
  const [users_actives, { data: ussss }] = useMutation(user_active, {
    refetchQueries: [
      { query: GetUsers, variables: { active: true, clientid: dropdown2[1] } },
      { query: GetUsers, variables: { active: false, clientid: dropdown2[1] } },
    ],
  });
  const [userregister, { data: reg }] = useMutation(register_active, {
    refetchQueries: [
      { query: GetUsers, variables: { active: true, clientid: dropdown2[1] } },
      { query: GetUsers, variables: { active: false, clientid: dropdown2[1] } },
    ],
  });

  const togless = () => {
    Active ? setActive(false) : setActive(true);
  };
  if (bulk_append) {
    return <BulkAppend CloseAppend={setbulk_append} />;
  }
  return (
    <div className="animate__animated animate__fadeIn">
      <div
        className={
          !bulk_append &&
          !bulk_update &&
          !manage_user_table &&
          !manage_user_form &&
          !temp_user_form &&
          !temp_edit_user_form
            ? ""
            : "hide-element"
        }
      >
        <div className="category-title">Users</div>

        <div className="dataadmin-user-action-group">
          <div className="user-action-card">
            <img
              className="user-action-image"
              alt=""
              src={require("../../../assets/images/material-playlist-add.svg")}
            />
            <button
              className="user-action-buttons"
              onClick={() => openBulkAppendUpdate("BulkAppend")}
            >
              Bulk Append
            </button>
          </div>

          <div className="user-action-card">
            <img
              className="user-action-image"
              src={require("../../../assets/images/feather-refresh.svg")}
              alt=""
            />
            <button
              className="user-action-buttons"
              onClick={() => {
                openBulkAppendUpdate("BulkUpdate");
              }}
            >
              Add User
            </button>
          </div>

          <div className="user-action-card">
            <img
              className="user-action-image"
              src={require("../../../assets/images/material-playlist-add.svg")}
              alt=""
            />
            <button
              onClick={() => openManageUser()}
              className="user-action-buttons"
            >
              Edit User
            </button>
          </div>
          <div className="user-action-card">
            <img
              className="user-action-image"
              src={require("../../../assets/images/material-playlist-add.svg")}
              alt=""
            />
            <button
              onClick={() => openTempUserForm()}
              className="user-action-buttons"
            >
              temp user form
            </button>
          </div>

          <div className="user-action-card">
            <img
              className="user-action-image"
              src={require("../../../assets/images/material-playlist-add.svg")}
              alt=""
            />
            <button
              onClick={() => openTempEditUserForm()}
              className="user-action-buttons"
            >
              edit user form
            </button>
          </div>
        </div>
      </div>

      {/* Bulk Append and update form*/}
      {/* <div className={bulk_append || bulk_update ? "" : "hide-element"}> */}
      <div className={bulk_update ? "" : "hide-element"}>
        <AddNewUser
          dataaAdminn={dataaAdminn}
          exist={exist}
          setEmail={setEmails}
          email={emails}
          addUserSimulator={addUserSimulator}
          addUserManager={addUserManager}
          addUserAircraft={addUserAircraft}
          addUserGround={addUserGround}
          addUserCrew={addUserCrew}
          addUserOptimiser={addUserOptimiser}
          userAddUsertable={userAddUsertable}
          adduserInregister={adduserInregister}
          closeForm={closeForm}
        />
      </div>

      {/* Manage Users table */}

      <div className={manage_user_table ? "" : "hide-element"}>
        <EditUser
          ActiveUserssoptimiser={ActiveUserssoptimiser}
          ActiveUserssdataAdminss={ActiveUserssdataAdminss}
          ActiveUserssmanagerss={ActiveUserssmanagerss}
          ActiveUserssaircraft={ActiveUserssaircraft}
          ActiveUsersssimulatorss={ActiveUsersssimulatorss}
          ActiveUserssGroundss={ActiveUserssGroundss}
          ActiveUserssCrews={ActiveUserssCrews}
          togless={togless}
          Active={Active}
          managerr1={managerr1}
          dataAdmin1={dataAdmin1}
          optimiser1={optimiser1}
          simulator1={simulator1}
          ground1={ground1}
          crew1={crew1}
          aircraft1={aircraft1}
          Active1={Active1}
          ActiveUserss={ActiveUserss}
          setoptimiser1={setoptimiser1}
          setdataAdmin1={setdataAdmin1}
          setActive1={setActive1}
          setmanagerr1={setmanagerr1}
          setsimulator1={setsimulator1}
          setCrew1={setCrew1}
          setGround1={setGround1}
          setAircraft1={setAircraft1}
          getuserss={getuserss}
          togle={togle}
          setdropdown2={setdropdown2}
          dropdown2={dropdown2}
          clientss={clientss}
          closeForm={closeForm}
          userregister={userregister}
          users_actives={users_actives}
          simulator_actives={simulator_actives}
          optimiser_actives={optimiser_actives}
          manager_actives={manager_actives}
          ground_activs={ground_activs}
          aircraft_actives={aircraft_actives}
          crew_actives={crew_actives}
          dataAdmin_actives={dataAdmin_actives}
        />
      </div>

      {/* add new user form */}

      <div className={manage_user_form ? "" : "hide-element"}>
        <div className="category-title">
          <span className="client-back" onClick={() => closeForm()}>
            {<LeftOutlined />} MANAGE USERS
          </span>
          Add New User & Assign Authorisations
        </div>

        <div className="toggle-form-container">
          <DropDownMenu title="Client" />
          <Text title="Official Email ID" />
          <Text
            title="Full Name (as per primary document)"
            character_limit="true"
            max_character="60"
          />
          <Text title="Employee ID" />
          <DropDownMenu title="Rank Code" />
          <Text title="Personal Email ID" />
          <Text title="Phone 1" />
          <Text title="Phone 2" />
          <Calender title="Date Of Birth" />
          <Calender title="Date Of Joining" />
          <DropDownMenu title="Fleet code ('All' for non-crew)" />
          <DropDownMenu title="Released/ Trainee" />
          <Text title="Permanent Address" />
          <Text title="Temporary Address" />
          <DropDownMenu title="Base Code" />
          <Text title="Primary License Number" />
          <DropDownMenu title="Responsible Manager" />
          <DropDownMenu title="Active" />
          <Calender title="Leaving Date" />
          <UploadLogo title="Photograph" />
          <div className="input-box-container">
            <div className="input-box-title">
              <span>Authorisations for this user</span>
            </div>
            <div className="checkbox-group">
              <Checkbox title="Crew" />
              <Checkbox title="Ground" />
              <Checkbox title="Aircraft" />
              <Checkbox title="Simulator" />
              <Checkbox title="Manager" />
              <Checkbox title="Optimizer" />
              <Checkbox title="Data Admin" />
            </div>
          </div>
          <button className="submit-button">Add</button>
          <button onClick={() => closeForm()} className="cancel-button">
            Cancel
          </button>
        </div>
      </div>

      {/* new start */}
      <div className={temp_user_form ? "" : "hide-element"}>
        <div className="category-title">User form</div>

        <div className="dataadmin-user-action-group">
          <div className="toggle-form-container">
            <form id="logForm" onSubmit={registerUser}>
              <div>
                <h5>Email</h5>
                <input type="email" id="userEmail" />
              </div>
              <div className={processing ? "hide-element" : ""}>
                <h5>Client</h5>
                <select
                  name="client"
                  value={userClient}
                  id="userClient"
                  onChange={(e) => {
                    setUserClient(e.target.value);
                  }}
                >
                  <option value="">-</option>
                </select>
              </div>
              <div>
                <span>Active</span>
                <input type="checkbox" id="activeStatus" />
              </div>
              <div>
                <span>Crew</span>
                <input type="checkbox" className="userAuth" title="Crew" />
              </div>
              <div>
                <span>Ground</span>
                <input type="checkbox" className="userAuth" title="Ground" />
              </div>
              <div>
                <span>Aircraft</span>
                <input type="checkbox" className="userAuth" title="Aircraft" />
              </div>
              <div>
                <span>Simulator</span>
                <input type="checkbox" className="userAuth" title="Simulator" />
              </div>
              <div>
                <span>Manager</span>
                <input type="checkbox" className="userAuth" title="Manager" />
              </div>
              <div>
                <span>Optimizer</span>
                <input type="checkbox" className="userAuth" title="Optimizer" />
              </div>
              <div>
                <span>Data Admin</span>
                <input
                  type="checkbox"
                  className="userAuth"
                  title="Data Admin"
                />
              </div>
              <div>
                <button type="submit">Register</button>
              </div>
            </form>
          </div>
        </div>
      </div>

      <div className={temp_edit_user_form ? "" : "hide-element"}>
        <div className="category-title">User form</div>

        <div className="dataadmin-user-action-group">
          <div className="toggle-form-container">
            <form id="updateForm" onSubmit={updateUser}>
              <div>
                <h5>Email</h5>
                <select
                  name="Email"
                  value={email}
                  id="updateEmail"
                  onChange={updateEmail}
                >
                  <option value="">-</option>
                </select>
              </div>
              <div className={processing ? "hide-element" : ""}>
                <h5>Client</h5>
                <select
                  name="client"
                  value={client}
                  id="updateClient"
                  onChange={(e) => {
                    setClient(e.target.value);
                  }}
                >
                  <option value="">-</option>
                </select>
              </div>
              <div className={processing ? "" : "hide-element"}>
                <h5>Waiting to fetch default client</h5>
              </div>
              <div>
                <span>Active</span>
                <input type="checkbox" id="updateStatus" />
              </div>
              <div>
                <span>Crew</span>
                <input type="checkbox" className="updateAuth" title="Crew" />
              </div>
              <div>
                <span>Ground</span>
                <input type="checkbox" className="updateAuth" title="Ground" />
              </div>
              <div>
                <span>Aircraft</span>
                <input
                  type="checkbox"
                  className="updateAuth"
                  title="Aircraft"
                />
              </div>
              <div>
                <span>Simulator</span>
                <input
                  type="checkbox"
                  className="updateAuth"
                  title="Simulator"
                />
              </div>
              <div>
                <span>Manager</span>
                <input type="checkbox" className="updateAuth" title="Manager" />
              </div>
              <div>
                <span>Optimiser</span>
                <input
                  type="checkbox"
                  className="updateAuth"
                  title="Optimiser"
                />
              </div>
              <div>
                <span>Data Admin</span>
                <input
                  type="checkbox"
                  className="updateAuth"
                  title="Data Admin"
                />
              </div>
              <div>
                <button type="submit">Update</button>
              </div>
            </form>
          </div>
        </div>
      </div>
      {/* new end */}
    </div>
  );
};
export default Users;
